<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
  import {mapActions} from 'vuex'

  export default {
    name: 'Print',
    methods: {
      ...mapActions('project', ['getImagesProject'])
    },

    mounted () {
      this.getImagesProject()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Tickets/Print.vue